import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import LoginPage from './components/LoginPage';
import { login } from './redux/slice';
import { Helmet } from 'react-helmet';
import { initGA, pageview } from '../../utilities/gtag'; // Adjust path if needed

const Login = () => {
  // useEffect(() => {
  //   document.title = 'Login to your Elite Samskruti Matrimony account';
  // }, []);

  useEffect(() => {
    initGA(); // Initialize GA once on mount
    pageview(window.location.pathname); // Track this pageview
  }, []);

  const { loading } = useSelector((state) => state.login);
  const dispatch = useDispatch();

  const [isStayLoggedInChecked, setIsStayLoggedInChecked] = useState(0);

  const onSubmit = (payload) => {
    dispatch(login(payload));
  };

  return (
    <>
      <Helmet>
        <title>Login to your Elite Samskruti Matrimony account</title>
        <meta
          name="description"
          content="Securely log in to your Elite Samskruti Matrimony account and access personalized AI-based match suggestions, profile updates, and communication tools."
        />
        <meta
          name="keywords"
          content="welcome, elite matrimony, matchmaking, Indian marriage"
        />
        <link rel="canonical" href="https://elite.lexyslabs.com/login" />

        {/* ✅ Add this robots meta tag here */}
        <meta name="robots" content="index, follow" />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Elite Samskruti Matrimony | Login Page"
        />
        <meta
          property="og:description"
          content="Find your perfect match through India’s most trusted matchmaking platform."
        />
        <meta
          property="og:image"
          content="https://elite.lexyslabs.com/preview.jpg"
        />
        <meta property="og:url" content="https://elite.lexyslabs.com/login" />
        <meta property="og:type" content="website" />

        {/* Twitter Meta */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Elite Samskruti Matrimony" />
        <meta
          name="twitter:description"
          content="Where elite families find their perfect match."
        />
        <meta
          name="twitter:image"
          content="https://elite.lexyslabs.com/preview.jpg"
        />
      </Helmet>
      <LoginPage
        loading={loading}
        onSubmit={onSubmit}
        isStayLoggedInChecked={isStayLoggedInChecked}
        setIsStayLoggedInChecked={setIsStayLoggedInChecked}
      />
    </>
  );
};

export default Login;
